<p-toast />
<div class="px-6 py-4">
  <div class="flex justify-content-between mb-4">
    <p class="text-xl font-semibold">{{ 'layout.configurations.runtimeSettings.title' | translate }}</p>
    <p-button
      *emPermission="Permission.CONFIG_BSA"
      class="p-button-success"
      icon="pi pi-save"
      [label]="'layout.configurations.runtimeSettings.save' | translate"
      (onClick)="onSubmit()"></p-button>
  </div>

  <form [formGroup]="runtimeSettingsForm">
    <div class="grid">
      <div class="col-12 md:col-12 lg:col-12 xl:col-6">
        <div class="flex flex-column gap-2 mb-4">
          <label for="socialSecurityProviderName"
            >{{ 'layout.configurations.runtimeSettings.socialSecurityProvider' | translate }}
          </label>
          <input
            pInputText
            id="socialSecurityProviderName"
            formControlName="socialSecurityProviderName"
            type="text"
            [placeholder]="'layout.configurations.runtimeSettings.socialSecurityProvider' | translate"
            [disabled]="!canWrite"
            class="w-full" />
          <em-input-error-message
            [errorMessage]="errorMessages.invalidSocialSecurityProviderName | translate"
            *ngIf="runtimeSettingsForm.get('socialSecurityProviderName')?.hasError('pattern')" />
          <em-input-error-message
            [errorMessage]="errorMessages.minLengthSocialSecurityProviderName | translate"
            *ngIf="runtimeSettingsForm.get('socialSecurityProviderName')?.hasError('minlength')" />
          <em-input-error-message
            [errorMessage]="errorMessages.maxLengthSocialSecurityProviderName | translate"
            *ngIf="runtimeSettingsForm.get('socialSecurityProviderName')?.hasError('maxlength')" />
        </div>

        <div class="flex flex-column gap-2 mb-4">
          <label for="secondaryPensionProvider">{{
            'layout.configurations.runtimeSettings.secondaryPensionProvider' | translate
          }}</label>
          <input
            pInputText
            id="secondaryPensionProvider"
            formControlName="secondaryPensionProvider"
            type="text"
            [placeholder]="'layout.configurations.runtimeSettings.secondaryPensionProvider' | translate"
            [disabled]="!canWrite"
            class="w-full" />
          <em-input-error-message
            [errorMessage]="errorMessages.invalidSecondaryPensionProvider | translate"
            *ngIf="runtimeSettingsForm.get('secondaryPensionProvider')?.hasError('pattern')" />
          <em-input-error-message
            [errorMessage]="errorMessages.minLengthSecondaryPensionProvider | translate"
            *ngIf="runtimeSettingsForm.get('secondaryPensionProvider')?.hasError('minlength')" />
          <em-input-error-message
            [errorMessage]="errorMessages.maxLengthSecondaryPensionProvider | translate"
            *ngIf="runtimeSettingsForm.get('secondaryPensionProvider')?.hasError('maxlength')" />
        </div>

        <div class="flex flex-column gap-2 mb-4">
          <label for="medicalInsuranceProvider">{{
            'layout.configurations.runtimeSettings.medicalInsuranceProvider' | translate
          }}</label>
          <input
            pInputText
            id="medicalInsuranceProvider"
            formControlName="medicalInsuranceProvider"
            type="text"
            [placeholder]="'layout.configurations.runtimeSettings.medicalInsuranceProvider' | translate"
            [disabled]="!canWrite"
            class="w-full" />
          <em-input-error-message
            [errorMessage]="errorMessages.invalidMedicalInsuranceProvider | translate"
            *ngIf="runtimeSettingsForm.get('medicalInsuranceProvider')?.hasError('pattern')" />
          <em-input-error-message
            [errorMessage]="errorMessages.minLengthMedicalInsuranceProvider | translate"
            *ngIf="runtimeSettingsForm.get('medicalInsuranceProvider')?.hasError('minlength')" />
          <em-input-error-message
            [errorMessage]="errorMessages.maxLengthMedicalInsuranceProvider | translate"
            *ngIf="runtimeSettingsForm.get('medicalInsuranceProvider')?.hasError('maxlength')" />
        </div>

        <div class="flex flex-column gap-2 mb-4">
          <label for="medicalVisitAuditMonths">{{ 'layout.configurations.runtimeSettings.medicalVisitAuditMonths' | translate }}</label>
          <input
            pInputText
            id="medicalVisitAuditMonths"
            formControlName="medicalVisitAuditMonths"
            type="number"
            min="0"
            max="60"
            [disabled]="!canWrite"
            class="w-full" />
        </div>

        <div class="flex flex-column gap-2 mb-4">
  <label for="academicalDegrees">{{
    'layout.configurations.runtimeSettings.academicalDegrees' | translate
  }}</label>
  <p-chips id="academicalDegrees" formControlName="academicalDegrees" class="w-full" [disabled]="!canWrite"></p-chips>
  <em-input-error-message
    [errorMessage]="errorMessages.invalidAcademicalDegrees | translate"
    *ngIf="runtimeSettingsForm.get('academicalDegrees')?.hasError('invalidListItem')" />
</div>

<div class="flex flex-column gap-2 mb-4">
  <label for="highSchoolDiplomaName">{{
    'layout.configurations.runtimeSettings.highSchoolDiplomaName' | translate
  }}</label>
  <p-chips id="highSchoolDiplomaName" formControlName="highSchoolDiplomaName" class="w-full" [disabled]="!canWrite"></p-chips>
  <em-input-error-message
    [errorMessage]="errorMessages.invalidHighSchoolDiplomaName | translate"
    *ngIf="runtimeSettingsForm.get('highSchoolDiplomaName')?.hasError('invalidListItem')" />
</div>

        <div class="flex flex-column gap-2 mb-4">
          <label for="contractDescription">{{
            'layout.configurations.runtimeSettings.contractDescription' | translate
          }}</label>
          <input
            pInputText
            id="contractDescription"
            formControlName="contractDescription"
            type="text"
            [placeholder]="'layout.configurations.runtimeSettings.contractDescription' | translate"
            [disabled]="!canWrite"
            class="w-full" />
          <em-input-error-message
            [errorMessage]="errorMessages.invalidContractDescription | translate"
            *ngIf="runtimeSettingsForm.get('contractDescription')?.hasError('pattern')" />
          <em-input-error-message
            [errorMessage]="errorMessages.minLengthContractDescription | translate"
            *ngIf="runtimeSettingsForm.get('contractDescription')?.hasError('minlength')" />
          <em-input-error-message
            [errorMessage]="errorMessages.maxLengthContractDescription | translate"
            *ngIf="runtimeSettingsForm.get('contractDescription')?.hasError('maxlength')" />
        </div>

        <div class="flex flex-column gap-2 mb-4">
          <label for="location">{{ 'layout.configurations.runtimeSettings.location' | translate }}</label>
          <p-dropdown
            id="location"
            formControlName="location"
            [options]="countries"
            [placeholder]="'layout.configurations.runtimeSettings.locationP' | translate"
            [disabled]="!canWrite"
            styleClass="w-full" />
        </div>

        <div class="flex flex-column gap-2 mb-4">
          <label for="appType">{{ 'layout.configurations.runtimeSettings.applicationType' | translate }}</label>
          <input
            pInputText
            id="appType"
            formControlName="appType"
            type="text"
            [placeholder]="'layout.configurations.runtimeSettings.applicationType' | translate"
            [disabled]="!canWrite"
            class="w-full" />
          <em-input-error-message
            [errorMessage]="errorMessages.invalidAppType | translate"
            *ngIf="runtimeSettingsForm.get('appType')?.hasError('pattern')" />
          <em-input-error-message
            [errorMessage]="errorMessages.minLengthAppType | translate"
            *ngIf="runtimeSettingsForm.get('appType')?.hasError('minlength')" />
          <em-input-error-message
            [errorMessage]="errorMessages.maxLengthAppType | translate"
            *ngIf="runtimeSettingsForm.get('appType')?.hasError('maxlength')" />
        </div>

        <div class="flex flex-column gap-2 mb-4">
          <label for="globalEmploymentType">{{
            'layout.configurations.runtimeSettings.globalEmploymentType' | translate
          }}</label>
          <p-multiSelect
            inputId="globalEmploymentType"
            formControlName="globalEmploymentType"
            [options]="globalEmploymentTypeOptions"
            optionLabel="label"
            optionValue="value"
            [showToggleAll]="true"
            [filter]="false"
            display="chip"
            [disabled]="!canWrite"
            appendTo="body"
            styleClass="w-full"
            [placeholder]="'layout.configurations.runtimeSettings.globalEmploymentTypePlaceholder' | translate">
          </p-multiSelect>
        </div>

        <div class="flex flex-column gap-2 mb-4">
          <label for="accountNumberLabel">{{
            'layout.configurations.runtimeSettings.accountNumberLabel' | translate
          }}</label>
          <input
            pInputText
            id="accountNumberLabel"
            formControlName="accountNumberLabel"
            type="text"
            [placeholder]="'layout.configurations.runtimeSettings.accountNumberLabel' | translate"
            [disabled]="!canWrite"
            class="w-full" />
          <em-input-error-message
            [errorMessage]="errorMessages.invalidAccountNumberLabel | translate"
            *ngIf="runtimeSettingsForm.get('accountNumberLabel')?.hasError('pattern')" />

          <em-input-error-message
            [errorMessage]="errorMessages.minLengthAccountNumberLabel | translate"
            *ngIf="runtimeSettingsForm.get('accountNumberLabel')?.hasError('minlength')" />

          <em-input-error-message
            [errorMessage]="errorMessages.maxLengthAccountNumberLabel | translate"
            *ngIf="runtimeSettingsForm.get('accountNumberLabel')?.hasError('maxlength')" />
        </div>

        <div class="flex flex-column gap-2 mb-4">
          <label for="accountNumberPattern">{{
            'layout.configurations.runtimeSettings.accountNumberPattern' | translate
          }}</label>
          <input
            pInputText
            id="accountNumberPattern"
            formControlName="accountNumberPattern"
            type="text"
            [placeholder]="'layout.configurations.runtimeSettings.accountNumberPattern' | translate"
            [disabled]="!canWrite"
            class="w-full" />
          <em-input-error-message
            [errorMessage]="errorMessages.minLengthAccountNumberPattern | translate"
            *ngIf="runtimeSettingsForm.get('accountNumberPattern')?.hasError('minlength')" />
          <em-input-error-message
            [errorMessage]="errorMessages.maxLengthAccountNumberPattern | translate"
            *ngIf="runtimeSettingsForm.get('accountNumberPattern')?.hasError('maxlength')" />
        </div>

        <div class="flex flex-column gap-2 mb-4">
          <label for="lastPromotionPeriod">{{
            'layout.configurations.runtimeSettings.lastPromotionPeriod' | translate
          }}</label>
          <input
            pInputText
            id="lastPromotionPeriod"
            formControlName="lastPromotionPeriod"
            type="text"
            [placeholder]="'layout.configurations.runtimeSettings.lastPromotionPeriod' | translate"
            [disabled]="!canWrite"
            class="w-full" />
          <em-input-error-message
            [errorMessage]="errorMessages.invalidLastPromotionPeriod | translate"
            *ngIf="runtimeSettingsForm.get('lastPromotionPeriod')?.hasError('pattern')" />
          <em-input-error-message
            [errorMessage]="errorMessages.maxLengthLastPromotionPeriod | translate"
            *ngIf="runtimeSettingsForm.get('lastPromotionPeriod')?.hasError('maxlength')" />
        </div>

        <div class="flex flex-column gap-2 mb-4">
          <label for="probationPeriodMonths">{{
            'layout.configurations.runtimeSettings.probationPeriodMonths' | translate
          }}</label>
          <input
            pInputText
            id="probationPeriodMonths"
            formControlName="probationPeriodMonths"
            type="text"
            [placeholder]="'layout.configurations.runtimeSettings.probationPeriodMonths' | translate"
            [disabled]="!canWrite"
            class="w-full" />
          <em-input-error-message
            [errorMessage]="errorMessages.invalidProbationPeriodMonths | translate"
            *ngIf="runtimeSettingsForm.get('probationPeriodMonths')?.hasError('pattern')" />
          <em-input-error-message
            [errorMessage]="errorMessages.maxLengthProbationPeriodMonths | translate"
            *ngIf="runtimeSettingsForm.get('probationPeriodMonths')?.hasError('maxlength')" />
        </div>

        <div class="flex flex-column gap-2 mb-4">
          <label for="entryLevelContractName">{{
            'layout.configurations.runtimeSettings.entryLevelContract' | translate
          }}</label>
          <p-chips
            id="entryLevelContractName"
            formControlName="entryLevelContractName"
            class="w-full"
            [disabled]="!canWrite"
            (onAdd)="rebuildContractNames()"
            (onRemove)="rebuildContractNames()">
          </p-chips>
        </div>
      </div>
      <div class="col-12 md:col-12 lg:col-12 xl:col-6">
        <div class="flex flex-column gap-2 mb-4">
          <label for="permanentContractName">{{
            'layout.configurations.runtimeSettings.permanentContract' | translate
          }}</label>
          <p-chips
            id="permanentContractName"
            formControlName="permanentContractName"
            class="w-full"
            [disabled]="!canWrite"
            (onAdd)="rebuildContractNames()"
            (onRemove)="rebuildContractNames()">
          </p-chips>
        </div>

        <div class="flex flex-column gap-2 mb-4">
          <label for="subContractorContractName">{{
            'layout.configurations.runtimeSettings.subcontractorContract' | translate
          }}</label>
          <p-chips
            id="subContractorContractName"
            formControlName="subContractorContractName"
            class="w-full"
            [disabled]="!canWrite"
            (onAdd)="rebuildContractNames()"
            (onRemove)="rebuildContractNames()">
          </p-chips>
        </div>

        <div class="flex flex-column gap-2 mb-4">
          <label for="secondaryPensionRatio">{{
            'layout.configurations.runtimeSettings.secondaryPensionRatio' | translate
          }}</label>
          <p-chips
            id="secondaryPensionRatio"
            formControlName="secondaryPensionRatio"
            class="w-full"
            [disabled]="!canWrite"></p-chips>
        </div>

        <div class="flex flex-column gap-2 mb-4">
          <label for="languageNames">{{ 'layout.configurations.runtimeSettings.languageNames' | translate }}</label>
          <p-chips id="languageNames" formControlName="languageNames" class="w-full" [disabled]="!canWrite"></p-chips>
        </div>

        <div class="flex flex-column gap-2 mb-4">
          <label for="languageLevels">{{ 'layout.configurations.runtimeSettings.languageLevels' | translate }}</label>
          <p-chips id="languageLevels" formControlName="languageLevels" class="w-full" [disabled]="!canWrite"></p-chips>
        </div>

        <div class="flex flex-column gap-2 mb-4">
          <label for="contractTerminationCauses">{{ 'layout.configurations.runtimeSettings.contractTerminationCauses' | translate }}</label>
          <p-chips id="contractTerminationCauses" formControlName="contractTerminationCauses" class="w-full" [disabled]="!canWrite"></p-chips>
        </div>

        <div class="flex flex-column gap-2 mb-4">
          <label for="contractNames">
            {{ 'layout.configurations.runtimeSettings.contractNames' | translate }}
          </label>

          <div
            id="contractNames"
            class="flex flex-wrap gap-2 w-full p-3 border-1 surface-border border-round min-h-3rem">
            <p-chip
              *ngFor="let contractName of runtimeSettingsForm.get('contractNames')?.value"
              [label]="contractName"
              [removable]="canWrite"
              (onRemove)="removeContractName(contractName)">
            </p-chip>

            <span *ngIf="!runtimeSettingsForm.get('contractNames')?.value?.length" class="text-500">
              {{ 'layout.configurations.runtimeSettings.noContractNames' | translate }}
            </span>
          </div>
        </div>

        <div class="flex flex-column gap-2 mb-4">
          <label for="activeSections">{{ 'layout.configurations.runtimeSettings.activeSections' | translate }}</label>
          <p-chips id="activeSections" formControlName="activeSections" class="w-full" [disabled]="!canWrite"></p-chips>
        </div>

        <div class="flex flex-column gap-2 mb-4">
          <label for="emailsNotificationList">
            {{ 'layout.configurations.runtimeSettings.emailsNotificationList' | translate }}
          </label>
          <p-chips id="emailsNotificationList" formControlName="emailsNotificationList" class="w-full" [disabled]="!canWrite"></p-chips>
          <small
            *ngIf="runtimeSettingsForm.get('emailsNotificationList')?.hasError('corporateEmailDomain')"
            class="p-error">
            {{ 'layout.configurations.runtimeSettings.errors.corporateEmailDomain' | translate }}
          </small>
        </div>

        <div class="flex flex-column gap-2 mb-4">
          <label for="dataRetentionYears">
            {{ 'layout.configurations.runtimeSettings.dataRetentionYears' | translate }}
          </label>
          <input
            pInputText
            id="dataRetentionYears"
            formControlName="dataRetentionYears"
            type="number"
            min="1"
            suffix=" years"
            [disabled]="!canWrite"
            class="w-full" />
        </div>

        <div class="flex flex-column gap-2 mb-4">
          <label for="worklogGenerationMonth">{{ 'layout.configurations.runtimeSettings.worklogGenerationMonth' | translate }}</label>
          <input
            pInputText
            id="worklogGenerationMonth"
            formControlName="worklogGenerationMonth"
            type="number"
            min="1"
            max="12"
            [disabled]="!canWrite"
            class="w-full" />
        </div>

        <div class="flex flex-column gap-2 mb-4">
          <label for="educationGrantMinAge">{{ 'layout.configurations.runtimeSettings.educationGrantMinAge' | translate }}</label>
          <input
            pInputText
            id="educationGrantMinAge"
            formControlName="educationGrantMinAge"
            type="number"
            min="0"
            max="99"
            [disabled]="!canWrite"
            class="w-full" />
        </div>

        <div class="flex flex-column gap-2 mb-4">
          <label for="educationGrantMaxAge">{{ 'layout.configurations.runtimeSettings.educationGrantMaxAge' | translate }}</label>
          <input
            pInputText
            id="educationGrantMaxAge"
            formControlName="educationGrantMaxAge"
            type="number"
            min="0"
            max="99"
            [disabled]="!canWrite"
            class="w-full" />
        </div>
      </div>
    </div>
    <!-- AFMA TYPES -->
    <div class="mt-5">
      <h3 class="text-lg font-semibold mb-3">
        {{ 'layout.configurations.runtimeSettings.afmaTypes.title' | translate }}
      </h3>
<div class="flex flex-wrap gap-2 mb-3">
 <div class="flex flex-wrap gap-2 mb-3">
  <p-chip
    *ngFor="let type of activeAfmaTypes"
    [label]="type.code"
    [removable]="canWrite"
    styleClass="blue-config-chip"
    (onRemove)="removeAfmaType(type.code)">
  </p-chip>
</div>

  <span
    *ngIf="activeAfmaTypes.length === 0"
    class="text-500">
    {{
      'layout.configurations.runtimeSettings.configurableTypes.noTypes'
        | translate
    }}
  </span>
</div>
      <div
        *ngIf="canWrite"
        [formGroup]="afmaTypeForm"
        class="grid">

        <div class="col-12 md:col-3">
          <label for="afmaCode">
            {{
              'layout.configurations.runtimeSettings.configurableTypes.code'
                | translate
            }}
          </label>

          <input
            pInputText
            id="afmaCode"
            formControlName="code"
            class="w-full mt-2" />
        </div>

        <div class="col-12 md:col-3">
          <label for="afmaLabelEn">
            {{
              'layout.configurations.runtimeSettings.configurableTypes.english'
                | translate
            }}
          </label>

          <input
            pInputText
            id="afmaLabelEn"
            formControlName="labelEn"
            class="w-full mt-2" />
        </div>

        <div class="col-12 md:col-3">
          <label for="afmaLabelEs">
            {{
              'layout.configurations.runtimeSettings.configurableTypes.spanish'
                | translate
            }}
          </label>

          <input
            pInputText
            id="afmaLabelEs"
            formControlName="labelEs"
            class="w-full mt-2" />
        </div>

        <div class="col-12 md:col-3">
          <label for="afmaLabelAr">
            {{
              'layout.configurations.runtimeSettings.configurableTypes.arabic'
                | translate
            }}
          </label>

          <input
            pInputText
            id="afmaLabelAr"
            formControlName="labelAr"
            class="w-full mt-2" />
        </div>

        <div class="col-12">
          <p-button
            type="button"
            icon="pi pi-plus"
            [label]="
              'layout.configurations.runtimeSettings.configurableTypes.add'
                | translate
            "
            (onClick)="addAfmaType()">
          </p-button>
        </div>
      </div>
    </div>

    <!-- MEDICAL VISIT TYPES -->
    <div class="mt-5">
      <h3 class="text-lg font-semibold mb-3">
        {{
          'layout.configurations.runtimeSettings.medicalVisitTypes.title'
            | translate
        }}
      </h3>

 <div class="flex flex-wrap gap-2 mb-3">
  <p-chip
    *ngFor="let type of activeMedicalVisitTypes"
    [label]="type.code"
    [removable]="canWrite"
    styleClass="blue-config-chip"
    (onRemove)="removeMedicalVisitType(type.code)">
  </p-chip>
  <span
    *ngIf="activeMedicalVisitTypes.length === 0"
    class="text-500">
    {{
      'layout.configurations.runtimeSettings.configurableTypes.noTypes'
        | translate
    }}
  </span>
</div>

      <div
        *ngIf="canWrite"
        [formGroup]="medicalVisitTypeForm"
        class="grid">

        <div class="col-12 md:col-3">
          <label for="medicalVisitCode">
            {{
              'layout.configurations.runtimeSettings.configurableTypes.code'
                | translate
            }}
          </label>

          <input
            pInputText
            id="medicalVisitCode"
            formControlName="code"
            class="w-full mt-2" />
        </div>

        <div class="col-12 md:col-3">
          <label for="medicalVisitLabelEn">
            {{
              'layout.configurations.runtimeSettings.configurableTypes.english'
                | translate
            }}
          </label>

          <input
            pInputText
            id="medicalVisitLabelEn"
            formControlName="labelEn"
            class="w-full mt-2" />
        </div>

        <div class="col-12 md:col-3">
          <label for="medicalVisitLabelEs">
            {{
              'layout.configurations.runtimeSettings.configurableTypes.spanish'
                | translate
            }}
          </label>

          <input
            pInputText
            id="medicalVisitLabelEs"
            formControlName="labelEs"
            class="w-full mt-2" />
        </div>

        <div class="col-12 md:col-3">
          <label for="medicalVisitLabelAr">
            {{
              'layout.configurations.runtimeSettings.configurableTypes.arabic'
                | translate
            }}
          </label>

          <input
            pInputText
            id="medicalVisitLabelAr"
            formControlName="labelAr"
            class="w-full mt-2" />
        </div>

        <div class="col-12">
          <p-button
            type="button"
            icon="pi pi-plus"
            [label]="
              'layout.configurations.runtimeSettings.configurableTypes.add'
                | translate
            "
            (onClick)="addMedicalVisitType()">
          </p-button>
        </div>
      </div>
    </div>

  </form>
</div>